import { useClerk } from '@clerk/react';
import { Link, Logo } from '@reelplicate/ui';
import { Outlet, useLocation } from 'react-router';

import { OnboardingStepper } from './onboarding-stepper';
import { stepFromPath } from './steps';

/**
 * Figma "Onboarding — *" frames: the Onboarding / Top bar (125:482; 72px,
 * bg/surface, border/subtle rule, 32px sides - wordmark, stepper, "Save and
 * exit") over a bg/subtle body that centres the step's card. Progress is
 * saved at every step, so "Save and exit" just signs out; signing back in
 * returns to the same step.
 */
export function OnboardingLayout() {
  const step = stepFromPath(useLocation().pathname);
  const { signOut } = useClerk();

  return (
    <div className="bg-bg-subtle flex min-h-svh flex-col">
      <header className="bg-bg-surface border-border-subtle flex h-[72px] shrink-0 items-center justify-between gap-6 border-b px-4 tablet:px-8">
        <Logo />
        <div className="hidden tablet:block">
          <OnboardingStepper current={step} />
        </div>
        <Link asChild tone="neutral" className="shrink-0">
          <button type="button" onClick={() => void signOut({ redirectUrl: '/sign-in' })}>
            Save and exit
          </button>
        </Link>
      </header>
      <main className="flex flex-1 items-center justify-center px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
